var _path, _path2, _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgInfo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_15_206)"
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M20 36C28.8366 36 36 28.8366 36 20C36 11.1634 28.8366 4 20 4C11.1634 4 4 11.1634 4 20C4 28.8366 11.1634 36 20 36Z",
    fill: "white"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask0_15_206",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 40,
    height: 40
  }, _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M40 0H0V40H40V0Z",
    fill: "white"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_15_206)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M20.0007 3.33325C10.8007 3.33325 3.33398 10.7999 3.33398 19.9999C3.33398 29.1999 10.8007 36.6666 20.0007 36.6666C29.2007 36.6666 36.6673 29.1999 36.6673 19.9999C36.6673 10.7999 29.2007 3.33325 20.0007 3.33325ZM20.0007 28.3333C19.084 28.3333 18.334 27.5833 18.334 26.6666V19.9999C18.334 19.0833 19.084 18.3333 20.0007 18.3333C20.9173 18.3333 21.6673 19.0833 21.6673 19.9999V26.6666C21.6673 27.5833 20.9173 28.3333 20.0007 28.3333ZM21.6673 14.9999H18.334V11.6666H21.6673V14.9999Z",
    fill: "#FF8C00"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_15_206"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 40,
    height: 40,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgInfo);
export default __webpack_public_path__ + "static/media/info.57eacafd80914da66b9a0ba62ddbc62e.svg";
export { ForwardRef as ReactComponent };